import DeviceRepository from '../../repositories/DeviceRepository';
import GroupRepository from '../../repositories/GroupRepository';
import Vue from 'vue';

export default {
	namespaced: true,
	state: {
		current: null
	},
	mutations: {
		SET_CURRENT: (state, device) => {
			state.current = device;
		},
		SET_NOTIFICATIONS: (state, notifications) => {
			Vue.set(state.current, 'notifications', notifications);
		},
		UPDATE_MONITOR_COUNT: (state, count) => {
			state.current.monitor_count = count;
		}
	},
	actions: {
		async refresh ({ commit, getters }, data) {
			return DeviceRepository.getDevice(data.clientId, data.groupId, data.deviceId)
				.then(data => {
					commit('SET_CURRENT', data);

					return data;
				});
		},
		async getWattboxLinks ({ commit, getters }, data) {
			return DeviceRepository.getWattboxLinks(data.clientId, data.groupId, data.deviceId);
		},
		notifications ({ commit, getters }, id) {
			return DeviceRepository.getNotifications(id)
				.then(data => {
					commit('SET_NOTIFICATIONS', data);

					return data;
				});
		},
		deactivate ({ commit, getters }, request) {
			return DeviceRepository.deactivateDevice(request.id)
				.then(data => {
					return data;
				});
		},
		deactivateBulk ({ commit, getters }, request) {
			return DeviceRepository.deactivateBulk(request);
		},
		activate ({ commit, getters }, request) {
			return DeviceRepository.activateDevice(request.id)
				.then(data => {
					return data;
				});
		},
		rebootDevice ({ commit, getters }, payload) {
			const id = typeof payload === 'object' ? payload?.id : payload;
			const outletNumber = typeof payload === 'object' ? payload?.outletNumber : null;
			return DeviceRepository.rebootDevice(id, outletNumber);
		},
		refreshDevice ({ commit, getters }, id) {
			return DeviceRepository.refreshDevice(id);
		},
		refreshSelection ({ commit, getters }, deviceList) {
			return DeviceRepository.refreshDeviceList(deviceList);
		},
		refreshAll ({ commit, getters }, requestData) {
			return GroupRepository.refreshDeviceAll(requestData.groupId, requestData.type);
		},
		fetchTypes ({ commit, getters }) {
			return DeviceRepository.getTypes();
		},
		fetchTypeAttributes ({ commit, getters }, type) {
			return DeviceRepository.getTypeAttributes(type);
		},
		search ({ commit, getters }, request) {
			return DeviceRepository.search(request);
		},
		getChildDevicesByType ({ commit, getters }, request) {
			return DeviceRepository.getChildrenByType(request);
		},
		fetchAttributeType ({ commit, getters }, id) {
			return DeviceRepository.getAttributeType(id);
		},
		/**
		 * get module data using the device repository
		 *
		 * @param commit vuex commit function
		 * @param getters vuex getters object
		 * @param request object containing the id of a device and the name of the module
		 * @returns {Promise<Array|Object|string>}
		 */
		fetchModuleData ({ commit, getters }, request) {
			return DeviceRepository.getModuleData(request.id, request.module);
		},
		/**
		 * use device repository to trigger screenshot sync for a single device
		 *
		 * @param commit vuex commit function
		 * @param getters vuex getters object
		 * @param {int} id id of a device
		 * @returns {Promise<Array|Object|string>}
		 */
		refreshDeviceScreenshot ({ commit, getters }, id) {
			return DeviceRepository.refreshDeviceScreenshot(id);
		},
		/**
		 * use device repository to trigger screenshot sync
		 * for multiple devices
		 *
		 * @param commit vuex commit function
		 * @param getters vuex getters object
		 * @param {array<int>} deviceList list of device ids
		 * @returns {Promise<Array|Object|string>}
		 */
		refreshSelectScreenshots ({ commit, getters }, deviceList) {
			return DeviceRepository.refreshSelectScreenshots(deviceList);
		},
		/**
		 * fetch the screenshot image from the core
		 *
		 * @param commit vuex commit function
		 * @param getters vuex getters object
		 * @param {int} deviceId id of the device
		 * @param {int} screenshotId id of the screenshot record
		 * @returns {Promise<Array|Object|string>}
		 */
		fetchScreenshotImage ({ commit, getters }, { deviceId, screenshotId, size }) {
			return DeviceRepository.getScreenshotImage(deviceId, screenshotId, size);
		}
	},
	getters: {
		current: state => state.current
	}
};
